import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    description:
      'Subject to confirmation, "**{recipientName}**" will receive **{amount}** {date}.',
    descriptionWithoutDate:
      'Subject to confirmation, "**{recipientName}**" will receive **{amount}**.',
    finish: 'Finish',
    title: 'International transfer taken into account!',
  },
  fr: {
    description:
      'Sous réserve de validation, "**{recipientName}**" recevra **{amount}** {date}.',
    descriptionWithoutDate:
      'Sous réserve de validation, "**{recipientName}**" recevra **{amount}**.',
    finish: 'Terminer',
    title: 'Virement international pris en compte !',
  },
} as const);
